import { useState, useEffect } from 'react';
import {
  isMobile, isDesktop as rddisDesktop, isSafari, isChrome, isIE,
} from 'react-device-detect';

export const useDeviceDetect = (returnOnlyDesktop = false) => {
  const [isDesktop, setIsDesktop] = useState(rddisDesktop);

  useEffect(() => {
    const checkDevice = () => {
      setIsDesktop(window.innerWidth >= 1024);
    };

    // Vérifier immédiatement
    checkDevice();

    // Ajouter l'écouteur d'événements
    window.addEventListener('resize', checkDevice);

    // Nettoyer l'écouteur d'événements
    return () => {
      window.removeEventListener('resize', checkDevice);
    };
  }, []);

  if (returnOnlyDesktop) {
    return isDesktop;
  }

  return { isDesktop, isMobile: !isDesktop };
}; 